import { NavLink, Outlet } from "react-router-dom";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { pathConstants } from "../../../../routes/pathContants";

export const StorefrontCover = () => {
  const menusTab = [
    {
      label: "Storefront",
      route: pathConstants.INVENTORY_MENU,
    },
    {
      label: "Shippings",
      route: pathConstants.INVENTORY_SHIPPINGS,
    },
    {
      label: "Riders",
      route: pathConstants.INVENTORY_RIDERS,
    },
  ];

  return (
    <div className={`${globalStyles.pageColumnGaps}`}>
      <div>
        <h4 className="mb-0">Online & In-Store Self Checkout</h4>
        <p>
          Let customers shop online or in-store, scan a QR code, and checkout
          effortlessly.
        </p>
      </div>

      <div className={globalStyles.rowNavigations}>
        {menusTab?.map((item, index) => (
          <NavLink
            end
            key={index}
            to={item?.route}
            className={({ isActive }) =>
              `${globalStyles.rowNavigations__item} ${
                isActive ? globalStyles.active : ""
              }`
            }
          >
            {item?.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
};
